export * from './safe-html/pipe.module';
export * from './safe-html/safe-html.pipe';
